import * as React from "react";
import * as utils from "../utils";
import moment from "moment";
import {Col, Label, Row} from "react-bootstrap";
import PercentageLabel from "./PercentageLabel";

export default class EntryRow extends React.Component{

    getUserName(user, userIsSelf){
        if(user && userIsSelf){
            return <strong>{user.name}</strong>;
        }
        if(user && !userIsSelf){
            return <span>{user.name}</span>;
        }
        return <em>unkown user</em>;
    }

    render(){

        const {entry, client, project, user, userIsSelf, task, hide, editingEntry, onItemClick, showUser} = this.props;

        const date = moment(entry.date, "YYYYMMDD").format("D-M-YY");


        const showAll = !hide || hide.length === 0;

        return <Row className={"entry" + (onItemClick ? " hoverable" : "") + ((editingEntry === entry.id) ? " active": "")}
                   onClick={() => {onItemClick && onItemClick(entry)}}>
            {(!hide || !hide.includes("project")) && project && (
                <Col sm={2} xs={8} className="project">
                    {showUser && (<div className="visible-xs">{this.getUserName(user, userIsSelf)}</div>)}
                    <PercentageLabel a={client.minutesTotal} b={client.budgetMinutesTotal} minutes={true} label="Client"/> &nbsp;
                    <strong>{client.name}</strong>
                    <br />
                    <PercentageLabel a={project.minutesTotal} b={project.budgetMinutesTotal} minutes={true} label="Project"/> &nbsp;
                    {project.name}
                    <div className="visible-xs">
                        <PercentageLabel a={task.minutesTotal} b={task.budgetMinutes} minutes={true} label="Task" /> &nbsp;
                        {task.name}
                    </div>
                </Col>
            )}

            <Col sm={4 - (showUser ? 1 : 0) - (showAll ? 1 : 0)}>
                {task && (
                    <div className="hidden-xs">
                        {!!task.minutesTotal && !!task.budgetMinutes && (
                            <PercentageLabel a={task.minutesTotal} b={task.budgetMinutes} minutes={true} label="Task" showPercentage/>
                        )}
                        <div className="task-name">
                            {task.label && (<span><Label>{task.label}</Label> &nbsp;</span>)}
                            {task.name}<br />
                        </div>
                    </div>
                )}
            </Col>
            {showUser && (
                <Col sm={2} className="hidden-xs">
                    {this.getUserName(user, userIsSelf)}
                </Col>
            )}
            {(!hide || !hide.includes("date")) && (
                <Col sm={2 - (showAll ? 1 : 0)} style={{textAlign: "right", wordBreak: "keep-all"}}>
                    {date}
                </Col>
            )}
            <Col sm={4 - (showUser ? 1 : 0)} className="description hidden-xs">
                {entry.description}<br />
            </Col>
            <Col sm={2} xs={4} style={{textAlign: "right"}}>
                {entry.minutes && utils.formatHours(entry.minutes)}
            </Col>
            <Col xs={12} className="visible-xs" style={{paddingTop: "5px", marginTop: "5px", borderTop: "1px solid #eee"}}>
                <em>{entry.description}</em>
            </Col>
        </Row>
    }
}

// export default connect()(EntryRow)


// WEBPACK FOOTER //
// ./src/components/EntryRow.js